import styled from '@mui/system/styled';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import CircularProgress from '../CircularProgress'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
export const BorderLinearProgressred = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRaduis: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        [`& .${linearProgressClasses.bar}`]: {
            borderRaduis: "5px",
            backgroundColor: theme.palette.mode === 'light' ? '#F52A59' : 'black'
        }
    }
}))
export const BorderLinearProgressgrey = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRaduis: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        [`& .${linearProgressClasses.bar}`]: {
            borderRaduis: "5px",
            backgroundColor: theme.palette.mode === 'light' ? '#bcbcbc' : 'black'
        }
    }
}))
export const BorderLinearProgressgreen = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRaduis: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        [`& .${linearProgressClasses.bar}`]: {
            borderRaduis: "10px",
            backgroundColor: theme.palette.mode === 'light' ? '#008C8D ' : 'black'
        }
    }
}))
export const BorderLinearProgressyellow = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRaduis: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        [`& .${linearProgressClasses.bar}`]: {
            borderRaduis: "10px",
            backgroundColor: theme.palette.mode === 'light' ? '#faaf00' : 'black'
        }
    }
}))
export const BorderCircularProgress = styled(CircularProgress)(({ theme }) => ({
    height: "100% !important",
    width: "60% !important",
    lineHeight: "1 !important",
    color: "#bcbcbc !important",
    '@media (min-width:768px) and (max-width:912px)': {
        height: "100% !important",
        width: "60% !important",
    },
    '@media (min-width:913px) ': {
        height: "100% !important",
        width: "100% !important",
    }

}))
export const CustomeFormControl = styled(FormControl)({
    width: "100%",
    margin: 0,
    "& label.Mui-focused": {
      color: "#008C8D "
    },

    "& .MuiSelect-icon": {
      color: "#008C8D "
    },
    "& .MuiInputLabel-root": {
      fontSize: "1rem !important"
    },
    "@media only screen and  (min-width:280px){": {
      "& .MuiInputLabel-root": {
        fontSize: "1rem !important"
      }
    },
    "@media (min-width:768px) and (max-width:912px)": {
      "& .MuiInputLabel-root": {
        fontSize: "1.2rem !important"
      },
      width: "100%"
    },
    "@media (min-width:913px) ": {
      "& .MuiInputLabel-root": {
        fontSize: "1.2rem !important"
      },
      "& .MuiSelect-icon": {
        color: "#008C8D "
      },
      width: "100%"
    }
  });
export const Customeselect = styled(Select)(({ locale }) => ({

    '& .MuiSelect-select': {
      textAlign: locale == "ar" ? "right" : "left"
    },

  }))


export const CustomeBorder = styled('div')(({ locale }) => ({
    borderRight: "none",
    '@media (min-width:768px) and (max-width:912px)': {

      borderRight: locale == "en" ? "1px solid #e0e0e0" : "0px",
      borderLeft: locale == "ar" ? "1px solid #e0e0e0" : "0px",
      boxSizing: "border-box",
      boxShadow: "0 0 4px #bcbcbc",
      border: "none",
      borderRadius: "2px",
      backgroundColor: "white",
      margin: "5px 25px",

    },
    '@media (min-width:913px) ': {
      borderRight: locale == "en" ? "1px solid #e0e0e0" : "0px",
      borderLeft: locale == "ar" ? "1px solid #e0e0e0" : "0px",
      boxSizing: "border-box",
      boxShadow: "0 0 4px #bcbcbc",
      border: "none",
      borderRadius: "2px",
      backgroundColor: "white",
      margin: "5px 25px",
    }
  }))